export const EV_FLEX_PROMO_CODE = 'BOLTEVFLEXGO'
export const EV_FLEX_SIMULATION_SO = 'EV Flex'
